module.exports = __webpack_public_path__ + "img/chevron-right.783e8f09.svg";